/* Shirts-Theme. 05.10.: Bewegung beim Scrollen — Einblenden ([data-zeige] → .ist-da), Scroll-Fortschritt als --p
   ([data-scroll] = raus | rein | durch, data-k streckt den Weg), Pointen-Bühne ([data-tour]), Karussell ([data-karussell]),
   Kopfleiste. Ohne JS und bei "weniger Bewegung" bleibt alles sichtbar und still (CSS hängt an html.bewegung).
   Produktseite: Bilder gross ansehen ([data-lupe]), Variantenwahl; ohne JS öffnet der Bildlink das Bild selbst und die
   Auswahlliste bleibt sichtbar. */
(function () {
  var html = document.documentElement;
  var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var alle = function (sel, wurzel) { return Array.prototype.slice.call((wurzel || document).querySelectorAll(sel)); };
  var klemme = function (x) { return x < 0 ? 0 : x > 1 ? 1 : x; };

  /* ---------- Einblenden ---------- */
  if (!still && 'IntersectionObserver' in window) {
    html.classList.add('bewegung');
    var io = new IntersectionObserver(function (eintraege) {
      eintraege.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('ist-da'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0 });
    alle('[data-zeige]').forEach(function (el) { io.observe(el); });
  }

  /* ---------- Scroll-Fortschritt --p ---------- */
  var scrollEls = still ? [] : alle('[data-scroll]');
  function fortschritt(vh) {
    scrollEls.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.bottom < -vh || r.top > 2 * vh) return;
      var k = parseFloat(el.getAttribute('data-k')) || 1, p;
      switch (el.getAttribute('data-scroll')) {
        case 'raus': p = -r.top / (r.height * k); break;          // 0 oben, 1 wenn k der Höhe hinausgescrollt ist
        case 'rein': p = (vh - r.top) / (vh * k); break;          // 0 am unteren Rand, 1 nach k Bildschirmhöhen
        default: p = (vh - r.top) / (vh + r.height);              // durch: ganzer Weg durchs Bild
      }
      el.style.setProperty('--p', klemme(p).toFixed(4));
    });
  }

  /* ---------- Pointen-Bühne ---------- */
  var tour = document.querySelector('[data-tour]');
  var tourRechnen = null;
  if (tour && !still) {
    var schritte = alle('.tour__schritt', tour);
    var punkte = alle('.tour__punkte li', tour);
    var laenge = tour.querySelector('.tour__laenge');
    if (schritte.length > 1 && laenge) {
      tour.classList.add('tour--buehne');
      var aktiv = -1;
      var setze = function (i) {
        if (i === aktiv) return;
        aktiv = i;
        schritte.forEach(function (s, k) {
          s.classList.toggle('ist-aktiv', k === i);
          if (k === i) s.removeAttribute('aria-hidden'); else s.setAttribute('aria-hidden', 'true');
        });
        punkte.forEach(function (pt, k) { pt.classList.toggle('ist-aktiv', k === i); });
      };
      tourRechnen = function (vh) {
        var r = laenge.getBoundingClientRect();
        var weg = r.height - vh;
        if (weg <= 0) return;
        setze(Math.min(schritte.length - 1, Math.floor(klemme(-r.top / weg) * schritte.length)));
      };
      punkte.forEach(function (pt, k) {
        pt.addEventListener('click', function () {
          var oben = laenge.getBoundingClientRect().top + window.scrollY;
          var weg = laenge.offsetHeight - window.innerHeight;
          window.scrollTo({ top: oben + weg * (k + 0.5) / schritte.length, behavior: 'smooth' });
        });
      });
      setze(0);
    }
  }

  /* ---------- Kopfleiste ---------- */
  var kopf = document.querySelector('[data-kopf]');

  var geplant = false;
  function rechne() {
    geplant = false;
    var vh = window.innerHeight;
    fortschritt(vh);
    if (tourRechnen) tourRechnen(vh);
    if (kopf) kopf.classList.toggle('ist-gescrollt', window.scrollY > 4);
  }
  function plane() { if (!geplant) { geplant = true; window.requestAnimationFrame(rechne); } }
  window.addEventListener('scroll', plane, { passive: true });
  window.addEventListener('resize', plane);
  rechne();

  /* Menü schliessen, wenn ein Anker im Menü angeklickt wird */
  alle('.menu__liste a').forEach(function (a) {
    a.addEventListener('click', function () { var m = a.closest('details'); if (m) m.open = false; });
  });

  /* ---------- Cookie-Einstellungen im Fuss ----------
     Shopifys Cookie-Banner (Einstellungen → Kundendatenschutz) bringt window.privacyBanner mit. Der Knopf erscheint
     nur, wenn es das Banner gibt, und öffnet dessen Auswahl erneut. Das Banner lädt nach der Seite, darum mehrmals prüfen. */
  var cookieKnopf = document.querySelector('[data-cookie-einstellungen]');
  if (cookieKnopf) {
    var cookieVersuche = 0;
    var cookiePruefen = function () {
      var banner = window.privacyBanner;
      if (banner && typeof banner.showPreferences === 'function') {
        cookieKnopf.hidden = false;
        cookieKnopf.addEventListener('click', function () { window.privacyBanner.showPreferences(); });
      } else if (++cookieVersuche < 10) {
        setTimeout(cookiePruefen, 600);
      }
    };
    cookiePruefen();
  }

  /* ---------- Karussell ---------- */
  alle('[data-karussell]').forEach(function (k) {
    var spur = k.querySelector('[data-spur]');
    var knoepfe = k.querySelector('[data-knoepfe]');
    var zurueck = k.querySelector('[data-zurueck]');
    var weiter = k.querySelector('[data-weiter]');
    if (!spur || !knoepfe) return;
    knoepfe.hidden = false;
    var schritt = function () {
      var karte = spur.querySelector('li');
      return karte ? karte.getBoundingClientRect().width + 20 : spur.clientWidth * 0.8;
    };
    var zustand = function () {
      zurueck.disabled = spur.scrollLeft < 8;
      weiter.disabled = spur.scrollLeft + spur.clientWidth > spur.scrollWidth - 8;
    };
    zurueck.addEventListener('click', function () { spur.scrollBy({ left: -schritt(), behavior: still ? 'auto' : 'smooth' }); });
    weiter.addEventListener('click', function () { spur.scrollBy({ left: schritt(), behavior: still ? 'auto' : 'smooth' }); });
    spur.addEventListener('scroll', zustand, { passive: true });
    window.addEventListener('resize', zustand);
    zustand();
  });

  /* ---------- Produktseite: Bilder gross ansehen ----------
     Klick auf ein Bild der Galerie öffnet es in einem Dialog. Blättern mit den Knöpfen, den Pfeiltasten oder per Wischen;
     Esc, × oder ein Klick neben das Bild schliesst. Mit gedrückter Strg-/Cmd-Taste öffnet der Link das Bild im neuen Tab. */
  var lupenLinks = alle('[data-galerie] a[data-lupe]');
  if (lupenLinks.length && window.HTMLDialogElement) {
    var pfeil = function (d) {
      return '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="' + d + '" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    };
    var lupe = document.createElement('dialog');
    lupe.className = 'lupe';
    lupe.setAttribute('aria-label', 'Bilder');
    lupe.innerHTML = '<figure class="lupe__bild"><img alt="" decoding="async"></figure>' +
      '<p class="lupe__zahl mono" aria-live="polite"></p>' +
      '<button type="button" class="rund lupe__zu" aria-label="Schliessen">' + pfeil('M6.5 6.5l11 11M17.5 6.5l-11 11') + '</button>' +
      (lupenLinks.length > 1
        ? '<button type="button" class="rund lupe__zurueck" aria-label="Vorheriges Bild">' + pfeil('M14.5 6 8.5 12l6 6') + '</button>' +
          '<button type="button" class="rund lupe__weiter" aria-label="Nächstes Bild">' + pfeil('m9.5 6 6 6-6 6') + '</button>'
        : '');
    document.body.appendChild(lupe);
    var lupeBild = lupe.querySelector('img');
    var lupeZahl = lupe.querySelector('.lupe__zahl');
    var n = lupenLinks.length, jetzt = 0;
    var zeige = function (i) {
      jetzt = (i % n + n) % n;
      var nr = jetzt, gross = lupenLinks[jetzt].href;
      var klein = lupenLinks[jetzt].querySelector('img');
      // Erst das schon geladene kleine Bild, dann das grosse, sobald es da ist: kein leeres Feld beim Blättern
      var schnell = klein && klein.complete && klein.naturalWidth ? klein.currentSrc || klein.src : '';
      lupeBild.src = schnell || gross;
      if (schnell && schnell !== gross) {
        var vorlade = new Image();
        vorlade.onload = function () { if (jetzt === nr) lupeBild.src = gross; };
        vorlade.src = gross;
      }
      lupeBild.alt = klein ? klein.alt : '';
      lupeBild.className = klein ? klein.className : '';
      lupeZahl.textContent = n > 1 ? (jetzt + 1) + ' / ' + n : '';
      if (n > 1) [jetzt + 1, jetzt - 1].forEach(function (k) { new Image().src = lupenLinks[(k % n + n) % n].href; });
    };
    lupenLinks.forEach(function (link, i) {
      link.addEventListener('click', function (e) {
        if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
        e.preventDefault();
        zeige(i);
        html.classList.add('lupe-offen');
        lupe.showModal();
      });
    });
    // Die Seitensperre gleich lösen: das close-Ereignis kommt erst mit dem nächsten Bild (in einem versteckten Tab gar nicht)
    var schliesse = function () { html.classList.remove('lupe-offen'); if (lupe.open) lupe.close(); };
    lupe.addEventListener('close', function () { html.classList.remove('lupe-offen'); });
    lupe.addEventListener('click', function (e) {
      var k = e.target.closest('button');
      if (k) {
        if (k.classList.contains('lupe__zu')) schliesse();
        else zeige(jetzt + (k.classList.contains('lupe__weiter') ? 1 : -1));
      } else if (e.target === lupe) {
        schliesse();
      }
    });
    lupe.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        e.preventDefault();
        schliesse();
      } else if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
        e.preventDefault();
        zeige(jetzt + (e.key === 'ArrowRight' ? 1 : -1));
      }
    });
    var startX = null, startY = 0;
    lupe.addEventListener('touchstart', function (e) {
      startX = e.touches.length === 1 ? e.touches[0].clientX : null;
      startY = e.touches[0].clientY;
    }, { passive: true });
    lupe.addEventListener('touchend', function (e) {
      if (startX === null || n < 2) return;
      var dx = e.changedTouches[0].clientX - startX, dy = e.changedTouches[0].clientY - startY;
      startX = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.2) zeige(jetzt + (dx < 0 ? 1 : -1));
    });
  }

  /* ---------- Produktseite: Variantenwahl ---------- */
  var wurzel = document.querySelector('[data-produkt]');
  if (!wurzel) return;
  var daten = document.querySelector('[data-produkt-json]');
  var produkt = daten ? JSON.parse(daten.textContent) : null;
  var auswahl = wurzel.querySelector('[data-variante]');
  var knopf = wurzel.querySelector('[data-kaufen]');
  var preis = wurzel.querySelector('[data-preis]');
  var felder = alle('fieldset[data-option-index]', wurzel);

  function chf(rappen) {
    return 'CHF ' + (rappen / 100).toFixed(2);
  }

  if (produkt && auswahl && felder.length) {
    felder.forEach(function (f) { f.hidden = false; });
    var ohneJs = wurzel.querySelector('[data-auswahl-ohne-js]');
    if (ohneJs) ohneJs.hidden = true;

    var aktuell = produkt.variants.find(function (v) { return String(v.id) === auswahl.value; }) || produkt.variants[0];

    var gewaehlt = function () {
      var werte = aktuell.options.slice();
      felder.forEach(function (f) {
        var i = +f.getAttribute('data-option-index');
        var an = f.querySelector('input:checked');
        if (an) werte[i] = an.value;
      });
      return werte;
    };

    var markiereVerfuegbarkeit = function () {
      felder.forEach(function (f) {
        var i = +f.getAttribute('data-option-index');
        alle('input', f).forEach(function (inp) {
          var probe = gewaehlt(); probe[i] = inp.value;
          var v = produkt.variants.find(function (x) { return x.options.every(function (o, k) { return o === probe[k]; }); });
          var label = f.querySelector('label[for="' + inp.id + '"]');
          if (label) label.classList.toggle('weg', !v || !v.available);
        });
      });
    };

    var aktualisiere = function () {
      var werte = gewaehlt();
      var v = produkt.variants.find(function (x) { return x.options.every(function (o, k) { return o === werte[k]; }); });
      if (v) {
        aktuell = v;
        auswahl.value = v.id;
        if (preis) preis.firstChild.nodeValue = chf(v.price);
        knopf.disabled = !v.available;
        knopf.textContent = v.available ? 'In den Warenkorb' : 'Ausverkauft';
        var url = new URL(location.href); url.searchParams.set('variant', v.id);
        history.replaceState(null, '', url);
      } else {
        knopf.disabled = true; knopf.textContent = 'Nicht erhältlich';
      }
      markiereVerfuegbarkeit();
    };

    felder.forEach(function (f) { f.addEventListener('change', aktualisiere); });
    markiereVerfuegbarkeit();
  }
})();
